import alt from 'framework/alt';
import { uniq, isArray } from 'lodash';
import I18nActions from 'actions/I18nActions';
import Domain from '../utils/Domain';
import { getLocalStrings, isLocalStringsEnabled } from '../../shared/utils/LocalUIStrings';

class I18nStore {
  constructor() {
    this.state = {
      strings: {},
      assets: [],
    };

    this.on('bootstrap', () => {
      const data = this.state;
      if (!isArray(data.i18n)) {
        this.fetchSucceeded(data.i18n);
      } else {
        Object.values(data.i18n).forEach((value) => {
          this.fetchSucceeded(value);
        });
      }
      delete data.i18n;
    });

    this.bindListeners({
      fetchStarted: I18nActions.fetchStarted,
      fetchSucceeded: I18nActions.fetchSucceeded,
      fetchFailed: I18nActions.fetchFailed,
      changeLocale: I18nActions.changeLocale,
    });
  }

  fetchStarted(asset) {
    this.setState({
      currentLocale: asset.locale,
      error: null,
      isLoading: true,
    });
  }

  fetchSucceeded(response) {
    let enDevLocalStrings = {};
    if (isLocalStringsEnabled(Domain.getDomain())) {
      enDevLocalStrings = getLocalStrings(response.assetName);
    }
    this.setState(prevState => ({
      strings: {
        ...prevState.strings,
        ...response.data.strings,
        ...enDevLocalStrings,
      },
      assets: uniq((prevState.assets || []).concat(response.assetName.toLowerCase())),
      error: null,
      currentLocale: response.locale,
      isLoading: false,
    }));
  }

  fetchFailed(response) {
    this.setState({
      error: response.error,
      isLoading: false,
    });
  }

  changeLocale(newLocale) {
    if (this.state.currentLocale !== newLocale) {
      this.setState({
        strings: {},
        assets: [],
        error: null,
        currentLocale: newLocale,
        isLoading: false,
      });
    }
  }
}

export default alt.createStore(I18nStore, 'I18nStore');
